import {
  Text,
} from 'web-styled';

import ExerciseResultListItem from './ExerciseResultListItem';
import * as S from './styled';

type Props = {
  exercises?: Array<any>,
};

const ExerciseResultList = ({ exercises = [] }: Props) => {
  const numbers = exercises?.map(item => item.number);

  return (
    <S.Body>
      {exercises?.length ? exercises.map((exercise, index) => (
        <ExerciseResultListItem
          key={exercise.id}
          exercise={exercise}
          nextNumber={numbers?.[index + 1]}
        />
      )) : (
        <Text color="#ccc">
          There are no exercises for this workout.
        </Text>
      )}
    </S.Body>
  );
};

export default ExerciseResultList;
